import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

//
import { Card, Col, Row } from "react-bootstrap";
import Moment from "react-moment";

//
import ImageBox from "../general/ImageBox";
import SmallChart from "./SmallChart";

//
import { iconImage } from "../../redux/features/coins/actions";

function BoxAvailableCoins({ items }) {
  return (
    <Row className="box-type">
      {items.map((item) => (
        <Col sm={6} lg={4} xxl={3} className="item" key={item.id}>
          <Card>
            <Card.Header>
              <div className="w-100">
                <div className="img-name-price">
                  <ImageBox src={iconImage(item.symbol.split("/")[0])} />
                  <div>
                    <p className="text-black fw-bolder ">{item.name}</p>
                    <small>
                      <span className="ms-0">Count Alert : </span>{" "}
                      <span className="text-black">{item.total_signals}</span>
                    </small>
                  </div>
                </div>

                <Link to={`/app/coin-detail/${item.symbol.split("/")[0]}`}>
                  <i className="las la-angle-right"></i>
                </Link>
              </div>
            </Card.Header>
            <Card.Body>
              <Row className="market-info">
                <Col xs={4}>
                  <div className="text-start item">
                    <small className="text-muted">
                      Last 3 Month Success Rate
                    </small>
                    <small className="text-black">
                      {Number(item.success_rate_3months).toFixed(2)}%
                    </small>
                  </div>
                </Col>
                <Col xs={4}>
                  <div className="text-center item">
                    <small className="text-muted">Success Rate</small>
                    <small className="text-black">
                      {Number(item.success_rate).toFixed(2)}%
                    </small>
                  </div>
                </Col>
                <Col xs={4}>
                  <div className="text-end item">
                    <small className="text-muted">
                      Avg. Max. Profit Per Alert
                    </small>
                    <small className="text-black">{item.avg_max_profit}%</small>
                  </div>
                </Col>
              </Row>

              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <small className="text-muted">Daily Vol. Change</small>
                  <small
                    className={`d-flex align-items-center ${
                      item.marketDetails.percent_change_24h > 0
                        ? "text-success"
                        : "text-danger"
                    }`}
                  >
                    {item.marketDetails.percent_change_24h.toFixed(2)}%
                    <i
                      className={`las la-arrow-${
                        item.marketDetails.percent_change_24h > 0
                          ? "up"
                          : "right"
                      }`}
                    />
                    <SmallChart
                      data={item.VolumeChartData_24}
                      last={item.marketDetails.percent_change_24h}
                    />
                  </small>
                </div>

                <div className="item text-end">
                  <small className="text-muted">Time Interval</small>
                  <small className="text-black">
                    <Moment utc fromNow>
                      {item.first_signal_date}
                    </Moment>
                  </small>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

BoxAvailableCoins.propTypes = {
  items: PropTypes.array.isRequired,
};

export default BoxAvailableCoins;
